import React, { Component } from 'react';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';

class YearSelector extends Component {

    state = {
        years: [2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028],
    }

    render() {
        const { name, changeSelectedYear, selectedYear } = this.props;

        return (
            <FormGroup controlId={'formControlsSelect'+name} bsSize="small">
                <FormControl componentClass="select" placeholder="select" onChange={changeSelectedYear} value={selectedYear}>
                    <option value="0">{React.Component.prototype.$intl.get('年')}</option>
                    { this.state.years.map((year, index) =>  <option  key={index} value={ year }> { year } </option>)}             
                </FormControl>
            </FormGroup>
        );
    }
  
}

export default YearSelector;
